import { render, staticRenderFns } from "./itemcategoryheaduser.vue?vue&type=template&id=16866906"
import script from "./itemcategoryheaduser.vue?vue&type=script&lang=js"
export * from "./itemcategoryheaduser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports